import SigPopconfirm from './SigPopconfirm'

export default SigPopconfirm
